"use client";
import React from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import { Segmant, NewItemData } from "../../../components";
import { Loader, Dropdown } from "semantic-ui-react";

class NhGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dimensions: {}, // store height per image index
    };
  }

  componentDidMount() {
    this.preloadImages();
  }

  preloadImages = () => {
    const { imageData } = this.props;

    if (typeof window === "undefined" || !imageData) return;

    imageData.forEach((image, index) => {
      const img = new window.Image();
      img.src = image.imageurl;

      img.onload = () => {
        this.setState((prev) => ({
          dimensions: {
            ...prev.dimensions,
            [index]: img.height,
          },
        }));
      };
    });
  };

  getImageHeight = (index) => {
    const modalbox = document.querySelector(".ReactModal__Content");

    if (modalbox && this.state.dimensions[index]) {
      return modalbox.offsetHeight - 125 + "px";
    }

    // fallback until loaded
    return "auto";
  };

  render() {
    const {
      imageData,
      selectedItem,
      user_id,
      is_editor,
      removephoto,
      editphotocaption,
      onRatemodal,
      is_static,
      modalhelpful,
      isloaderactive,
      ismodalopen,
      islistingmodalopen,
    } = this.props;

    const rateoptions = ["1", "2", "3", "4", "5"].map((val) => ({
      key: val,
      text: val,
      value: val,
    }));

    return (
      <div>
        <Segmant className="pr-0 popup_slider">
          {islistingmodalopen ? (
            <Carousel
              showIndicators={false}
              infiniteLoop={true}
              autoPlay={false}
              interval={2000}
              selectedItem={selectedItem}
            >
              {imageData &&
                ismodalopen &&
                imageData.map((image, index) => {
                  const imgHeight = this.getImageHeight(index);

                  return (
                    <div
                      key={index}
                      id={`imgdata${index}`}
                      style={{
                        height: imgHeight,
                        width: image.username ? "80%" : "100%",
                      }}
                    >
                      <img
                        src={image.imageurl + "?cacheblock=true"}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/defaultadd.jpg";
                        }}
                        crossOrigin="anonymous"
                        style={{ height: imgHeight }}
                        title="Neighborhood Photo"
                        alt="Neighborhood Photo"
                      />

                      {/* description part */}
                      <div className="model_slider_desc">
                        {image.username && (
                          <NewItemData
                            size="tiny"
                            source={
                              image.userimage &&
                              image.userimage !== "$context.arguments.userimage"
                                ? image.userimage
                                : process.env.NEXT_PUBLIC_CDN_ID +
                                  "static/images/Milad.png"
                            }
                            head={image.username}
                            subhead={image.userrole}
                            href="/ProfileRealtor"
                            className="user_data_modal"
                            userid={image.user_id}
                          />
                        )}

                        {is_static === false && (
                          <>
                            {image.caption && (
                              <p className="slider_cap">{image.caption}</p>
                            )}
                            {image.listingby && (
                              <p className="slider_cap">
                                Photo from listing by: {image.listingby}
                              </p>
                            )}

                            {image.user_id === user_id ? (
                              <span className="helpful_slider" disabled>
                                <i
                                  aria-hidden="true"
                                  className="thumbs up outline icon"
                                ></i>{" "}
                                Helpful {image.imagehelpfulcount}
                              </span>
                            ) : (
                              user_id && (
                                <span
                                  className="helpful_slider"
                                  onClick={(e) =>
                                    modalhelpful(e, image.id, image)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    aria-hidden="true"
                                    className="thumbs up outline icon"
                                  ></i>{" "}
                                  Helpful {image.imagehelpfulcount}{" "}
                                  {isloaderactive && (
                                    <Loader size="mini" inline active />
                                  )}
                                </span>
                              )
                            )}

                            {image.user_id === user_id && (
                              <div className="photo_owners">
                                <p>Photo Owner's View</p>
                                <span
                                  style={{
                                    color: "#4183c4",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) =>
                                    editphotocaption(e, image.id, image.caption)
                                  }
                                >
                                  <i className="pencil alternate icon"></i> Edit
                                  photo caption
                                </span>
                                <br />
                                <span
                                  style={{
                                    color: "#4183c4",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => removephoto(e, image.id)}
                                >
                                  <i className="trash alternate icon"></i>{" "}
                                  Remove photo
                                </span>
                              </div>
                            )}

                            {is_editor && (
                              <div className="editors_view">
                                <p>Editors's View</p>
                                <span
                                  style={{
                                    color: "#4183c4",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => removephoto(e, image.id)}
                                >
                                  <i className="trash alternate icon"></i>{" "}
                                  Remove photo
                                </span>
                                <br />
                                <span className="rate_drpdwn rate_drpdwn_modal">
                                  <Dropdown
                                    text="Rate"
                                    floating
                                    labeled
                                    button
                                    upward
                                  >
                                    <Dropdown.Menu>
                                      <Dropdown.Header content="Rate" />
                                      {rateoptions.map((option) => (
                                        <Dropdown.Item
                                          key={option.value}
                                          {...option}
                                          onClick={(e) =>
                                            onRatemodal(image.id, e)
                                          }
                                        />
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </span>
                                <span>{image.rate}</span>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
            </Carousel>
          ) : (
            <Loader active inline="centered" size="massive" />
          )}
        </Segmant>
      </div>
    );
  }
}

NhGallery.propTypes = {
  imageData: PropTypes.array.isRequired,
  selectedItem: PropTypes.number,
  user_id: PropTypes.string,
  is_editor: PropTypes.bool,
  removephoto: PropTypes.func,
  editphotocaption: PropTypes.func,
  onRatemodal: PropTypes.func,
  is_static: PropTypes.bool,
  modalhelpful: PropTypes.func,
  isloaderactive: PropTypes.bool,
  ismodalopen: PropTypes.bool,
  islistingmodalopen: PropTypes.bool,
};

export default NhGallery;
